import { useState } from "react";
import { Button, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import "./NNLeaseGDPR.css";

function NnLeaseGdpr(props) {
  const { toggle, setAgreementValue, agreementValue } = props;
  const [approve, setApprove] = useState(
    agreementValue ? agreementValue : false
  );
  let classes = "checkmark";

  const handleApproveChange = (e) => {
    setApprove(!approve);
    setAgreementValue(!approve);
  };
  return (
    <div>
      <ModalHeader
        toggle={toggle}
        tag="h6"
        cssModule={{ "modal-title": "w-100 text-center" }}
      >
        Nota de informare privind prelucrarea datelor cu caracter personal
      </ModalHeader>
      <ModalBody>
        <div className="pt-3">
          Prezenta Nota de informare contine informatii relevante pentru
          prelucrarea datelor tale cu caracter personal in contextul activitatii
          de intermediere credite efectuata de catre NN Lease SRL (denumit in
          cele ce urmeaza „NN Lease”) si a prezentarii ofertei de creditare a
          ING Bank NV Sucursala Bucuresti (denumita in cele ce urmeaza „ING Bank
          ”).
        </div>
        <div className="pt-3">
          <div className="mt-3 p-1 bg-warning">
            <h2 className="h6 mb-1">
              1. Identitatea si calitatea entitatilor care prelucreaza datele cu
              caracter personal
            </h2>
          </div>
          <div className="pt-3">
            In vederea realizarii activitatii de intermediere credite, generare
            leaduri credit si facilitare a initierii unui raport contractual de
            creditare:
          </div>
          <ul className="pt-3">
            <li>
              {" "}
              <span className="font-weight-bold">ING Bank</span>, societate
              bancara, inmatriculata si existand in conformitate cu legislatia
              Olandei, avand sediul social in Bucuresti, str. Av. Popisteanu nr.
              54A, Expo Business Park, Cladirea 3, cod postal 012095, Sector 1,
              Romania , inregistrat la Registrul Comertului Bucuresti sub nr.
              J40/16100/1994, cod de identificare fiscala nr. RO6151100,
              inregistrata in Registrul bancar sub nr. RB-PJS-40-024/1999{" "}
              <span className="font-weight-bold">si</span>
            </li>
            <li>
              <span className="font-weight-bold">NN Lease</span>, intermediar de
              credite nelegat care ofera servicii de asistenta si nu percepe
              comision de la clienti, cu sediul social in București, Sector 5,
              Str. Sergent Nuțu Ion nr. 44, Corp B, etaj 2, inregistrata la
              Registrul Comertului al Municipiului Bucuresti sub nr.
              J40/9811/1999, cod unic de inregistrare RO12437824
            </li>
          </ul>
          actioneaza in calitate de{" "}
          <span className="font-weight-bold">Operatori asociati</span>.
          <div className="pt-3">
            Entitatile sus mentionate vor prelucra:
            <ul className="pt-3 latin-list">
              <li>Datele tale de identificare (nume, prenume, CNP);</li>
              <li>
                Datele tale de contact (adresa de e-mail, numar de telefon);
              </li>
              <li>
                Informatii legate de venit, vechime si continuitate in munca;
              </li>
              <li>
                Informatii privind modul in care ti-ai indeplinit angajamentele
                de plata in relatie cu alte rapoarte de creditare;
              </li>
              <li>Informatii privind imobilele avute in proprietate;</li>
              <li>Informatii privind produsele de creditare solicitate.</li>
            </ul>
            <div className="pt-3">
              {" "}
              Informatiile mentionate anterior sunt captate de reprezentantul NN
              Lease fiind supuse prelucrarii de catre NN Lease si ING Bank
              conform scopurilor detaliate in continuare.
            </div>
            <div>
              {" "}
              De asemenea, pot fi supuse prelucrarii efectuata de Operatorii
              asociati, in contextul generarii de rapoarte periodice de
              activitate, informatii privind statusul leadului (inclusiv motivul
              refuzului) si/sau solicitarii de credit si informatii referitoare
              la creditul solicitat inclusiv intervalul valoric asociat acestuia
              precum si data disbursarii.
            </div>
          </div>
        </div>
        <div className="pt-3">
          <div className="mt-3 p-1 bg-warning">
            <h2 className="h6 mb-1">
              2. Scopul si temeiul prelucrarii datelor cu caracter personal
            </h2>
          </div>
          <div className="pt-3">
            Datele cu caracter personal amintite anterior vor fi supuse
            prelucrarii in vederea indeplinirii obligatiilor legale ce revin
            Operatorilor asociati, pentru realizarea demersurilor prealabile
            necesare incheierii unui contract dar si pentru indeplinirea
            intereselor legitime ale acestora de a pastra evidente relevante
            pentru asigurarea bunei administrari a parteneriatului, inclusiv din
            perspectiva comisionarii aferente activitatii de intermediere
            credite.
          </div>
          <div className="pt-3">
            In concret, datele tale, in calitate de Persoana vizata, vor fi
            prelucrate pentru:
            <ul className="pt-3">
              <li>
                Identificare, captare a nevoii de finantare si adaptare a
                lead-ului generat la specificul fiecarui solicitant, in functie
                de veniturile, angajamentele de plata si bunurile imobile
                detinute de acesta;
              </li>
              <li>
                Indeplinire a obligatiilor de informare si transparentizare ce
                ne revin atat in calitate de operatori de date cu caracter
                personal cat si in baza prevederilor legale aplicabile in
                materia contractelor de credit ipotecare dedicate
                consumatorilor;
              </li>
              <li>
                Contactare a solicitantului de credit, ca urmare a receptionarii
                unui lead generat la nivel de NN Lease de catre reteaua de
                Office-uri ale ING Bank;
              </li>
              <li>
                Asigurarea unei bune gestiuni a leadurilor inclusiv din
                perspectiva contactarii timpurii, calculului si previzionarii de
                comisioane si analizei de portofoliu.
              </li>
            </ul>
          </div>
          <div className="pt-3">
            Prelucrarea datelor cu caracter personal este necesara atat pentru a
            putea facilita preluarea lead-ului si initierea unor demersuri de
            analiza precontractuala cat si pentru indeplinirea obligatiilor
            legale ce revin Operatorilor asociati, in acest context, refuzul de
            a furniza aceste date are ca efect imposibilitatea prestarii
            serviciului.
          </div>
          <div className="pt-3">
            Datele cu caracter personal sunt supuse prelucrarii pentru o
            perioada de timp necesara indeplinirii scopurilor sus mentionate.
          </div>
        </div>
        <div className="pt-3">
          <div className="mt-3 p-1 bg-warning">
            <h2 className="h6 mb-1">3. Destinatari si transfer de date</h2>
          </div>
          <div className="pt-3">
            Destinatarii datelor tale sunt Operatorii Asociati si entitatile
            membre ale grupului ING, institutiile si autoritatile de stat cu
            prerogative de supraveghere si control precum si entitati
            contractate de Operatori pentru indeplinirea de activitati
            determinate precum stocare de informatii si/sau arhivare.
          </div>
          <div className="pt-3">
            In eventualitatea unui transfer de date in afara Spatiului Economic
            European garantam protejarea datelor tale conform cerintelor
            aplicabile in materie, respectiv prin asigurarea de garantii
            adecvate transferului precum incheierea de conventii contractuale
            bazate pe Clauze Contractuale Standard astfel cum acestea au fost
            emise de catre Comisia Europeana si/sau aplicarea Regulilor
            Corporatiste Obligatorii precum si realizarea de analize de risc
            pentru a asigura identificarea si implementarea masurilor de
            protectie adecvate.
          </div>
        </div>
        <div className="pt-3">
          <div className="mt-3 p-1 bg-warning">
            <h2 className="h6 mb-1">4. Drepturi de care dispui </h2>
          </div>
          <div className="pt-3">
            In calitate de Persoana vizata te informam ca dispui de urmatoarele
            drepturi conform Regulamentului European pentru Protectia Datelor cu
            Caracter Personal 679/2016, respectiv de:
          </div>
          <div className="pt-3">
            <h3 className="h6 mb-0 mt-2">Dreptul de acces la date </h3>
            <div>
              Ai dreptul de a ne solicita sa confirmam prelucrarea datelor tale
              cu caracter personal si sa iti furnizam un raport al datelor cu
              caracter personal pe care le prelucram.
            </div>
            <h3 className="h6 mb-0 mt-2">Dreptul la rectificare </h3>
            <div>
              Daca datele cu caracter personal sunt incorecte, ai dreptul sa ne
              ceri sa le rectificam. In cazul in care comunicam tertilor date
              corectate ulterior, vom informa si tertii respectivi in acest
              sens.
            </div>
            <h3 className="h6 mb-0 mt-2">Dreptul la opozitie </h3>
            <div>
              Exercitarea acestui drept permite Persoanei vizate sa se opuna
              folosirii datelor sale personale in vederea indeplinirii
              intereselor legitime ale Operatorilor Asociati. Te rugam sa
              incluzi in solicitare si motivele legate de situatia ta
              particulara ce au dus la exercitarea dreptului de opozitie; acest
              lucru ne va permite sa efectuam analiza necesara pentru furnizarea
              unui raspuns.
            </div>
            <h3 className="h6 mb-0 mt-2">
              Dreptul la restrictionarea prelucrarii{" "}
            </h3>
            <div>
              Ai dreptul de a ne solicita sa restrictionam utilizarea datelor
              tale cu caracter personal in cazul in care: consideri ca
              informatiile sunt inexacte; prelucram datele in mod ilegal;
              Operatorii asociati nu mai au nevoie de datele respective, dar
              doresti sa le pastram in vederea utilizarii intr-o actiune in
              justitie; te-ai opus prelucrarii datelor tale, solicitarea de
              restrictionare fiind aplicabila pana la finalizarea analizei
              interne si oferirea unei rezolutii in privinta exercitarii
              dreptului de opozitie.
            </div>
            <h3 className="h6 mb-0 mt-2">Dreptul la portabilitatea datelor </h3>
            <div>
              Ai dreptul sa ne soliciti sa iti transferam datele cu caracter
              personal direct sau unei alte companii. Aceasta se aplica in cazul
              datelor cu caracter personal pe care le prelucram prin mijloace
              automatizate si cu consimtamantul acesteia sau pe baza unui
              contract incheiat cu aceasta. In cazul in care transferul catre
              compania indicata nu este posibil din punct de vedere tehnic, iti
              vom transfera datele cu caracter personal mentionate anterior,
              intr-un format structurat, care poate fi citit automat.
            </div>
            <h3 className="h6 mb-0 mt-2">Dreptul la stergere </h3>
            <div>
              Ai dreptul de a solicita sa iti stergem datele cu caracter
              personal, fara intarzieri nejustificate, in cazul in care se
              aplica unul dintre urmatoarele motive: acestea nu mai sunt
              necesare pentru indeplinirea scopurilor pentru care au fost
              colectate sau prelucrate; iti retragi consimtamantul si nu exista
              niciun alt temei juridic pentru prelucrare; te opui prelucrarii si
              nu exista motive legitime care sa prevaleze; datele cu caracter
              personal au fost prelucrate ilegal; datele cu caracter personal
              trebuie sterse pentru respectarea unei obligatii legale; datele cu
              caracter personal au fost colectate in legatura cu oferirea de
              servicii ale societatii informationale.
            </div>
            <h3 className="h6 mb-0 mt-2">Dreptul de a depune o plangere </h3>
            <div>
              Dispui de dreptul de a te adresa Autoritatii Nationale pentru
              Supravegherea Prelucrarii Datelor cu Caracter personal sau
              instantelor de judecata, in masura in care consideri ca oricare
              dintre Operatorii asociati nu au avut o conduita conforma.
            </div>
          </div>
          <div className="pt-3">
            Informatii suplimentare privind activitatea de prelucrare efectuata
            de catre <span className="font-weight-bold">ING Bank</span>, in
            calitate de Operator de date poti gasi in documentatia cadru a
            relatiei de afaceri (in eventualitatea contractarii unui credit sau
            daca aveti deja o relatie de afaceri in desfasurare cu noi -
            Conditii Generale de Afaceri) si respectiv pe website-ul nostru
            ing.ro pe sectiunea dedicata Protectiei Datelor cu Caracter
            Personal.
            <div>
              In mod similar, informatii aditionale privind activitatea de
              prelucrare date efectuata de{" "}
              <span className="font-weight-bold">NN Lease</span>, ca si operator
              de date independent (pentru acele activitati de prelucrare ce
              exced celor prezentate in prezenta Nota de informare, dedicata
              asocierii NN Lease- ING Bank), poti gasi pe website-ul nnlease.ro
              in sectiunea Protectia datelor.
            </div>
          </div>
          <div className="pt-3"></div>
        </div>
        <div className="pt-3">
          <div className="mt-3 p-1 bg-warning">
            <h2 className="h6 mb-1">5. Date de contact</h2>
          </div>
          <div className="pt-3">
            Drepturile sus mentionate sau solicitari privind cele mentionate in
            aceasta Nota de informare pot fi transmise:
          </div>
          <ul className="pt-3 caret-list">
            <li>
              in atentia ING Bank prin e-mail pe adresele{" "}
              <a href="mailto:contact@ing.ro">contact@ing.ro</a>/
              protectiadatelor@ing.ro (pentru a primi feedback specializat din
              partea Responsabilului cu Protectia Datelor desemnat la nivelul
              ING Bank), prin posta la adresa la ING Bank Romania, str. Aviator
              Popisteanu nr. 54A, Expo Business Park, Cladirea nr. 3, sector 1,
              Bucuresti, 012095 sau telefon *2ING (*2464).
            </li>
            <li>
              in atentia NN Lease prin e-mail pe adresa{" "}
              <a href="mailto:dpo@nnlease.ro">dpo@nnlease.ro</a>, prin posta la
              adresa NN Lease Str. Sergent Nuțu Ion nr. 44, Corp B, etaj 2, Sector 5,
              cod poștal: 050762, București
            </li>
          </ul>
        </div>

        <div className="pt-3">
          <div className="checkbox-container checkbox-warning-filled mb-2 pr-4">
            <div className="d-inline-block">
              <label className="form-check-label checkbox-label d-inline-block">
                <input
                  type="checkbox"
                  name="approve"
                  className={"form-check-input"}
                  onClick={handleApproveChange}
                  onChange={handleApproveChange}
                  checked={approve}
                  value={approve}
                />
                <span className={classes}></span>
                <div className="field-label d-inline-block cursor-pointer">
                  Am luat la cunostinta
                </div>
              </label>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Închide
        </Button>
      </ModalFooter>
    </div>
  );
}

export default NnLeaseGdpr;
